import { useEffect, useMemo, useState } from 'preact/hooks';
import { useControls } from './hooks/useControls';
import { PX } from './social/lib';

function useFontBoostCalculator(fontSize: number) {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = document.createElement('div');
    el.id = 'useFontBoostCalculatorHelper';
    document.body.appendChild(el);
    setElement(el);

    return () => document.body.removeChild(el);
  }, []);

  return useMemo(() => {
    if (!element || !fontSize) return 1;

    element.style.setProperty('font-size', PX(fontSize));

    const computedStyle = getComputedStyle(element);
    const actualFontSize = parseFloat(computedStyle.fontSize) || fontSize;

    return actualFontSize / fontSize;
  }, [element, fontSize]);
}

export function useFontBoost() {
  const { renderSlot } = useControls();
  const fontBoost = useFontBoostCalculator(16);

  useEffect(() => {
    renderSlot.style.setProperty('--font-boost', fontBoost.toString());
  }, [renderSlot, fontBoost]);
}
